import {
  Col,
  Typography,
  Row,
  Button,
  Form,
  Input,
} from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import rider from "../../assets/images/rider.png";
import { bindActionCreators } from "redux";
import * as authActions from "../../redux/actions/auth.actions";
import { connect } from "react-redux";

const { Title } = Typography;

const MartLogin = ({ navigation, authActions, user_loading }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    navigation = navigate;
    await authActions.loginUserMartAction(
      values.email,
      values.password,
      navigation
    ).then((res) => {
    });
  };

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  return (
    <div className="LoginPage">
      <div className="page-content">
        <Row justify="middle" className="CustomLoginRow">
          <Col span={11}>
            <Title level={1} className="formHeading" align="center">
              Welcome to Rocky Back Office Mart Login
            </Title> 
            <Form
              name="login"
              layout="vertical"
              className="loginForm"
              initialValues={{
                remember: true,
              }}
              onFinish={handleSubmit}
              autoComplete="off"
              style={{ maxWidth: "50%", margin: "0 auto" }}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "Please enter your email!",
                  },
                ]}
              >
                <Input value={credentials.email} onChange={onChange} />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password!",
                  },
                ]}
              >
                <Input.Password
                  name="password"
                  value={credentials.password}
                  onChange={onChange}
                />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  span: 24,
                }}
              >
                <Button type="primary" loading={user_loading} htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <figure>
              <img src={rider} alt="" width="100%" height="auto" />
            </figure>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    user_loading: state.authReducer.user_loading,
    error: state.authReducer.error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MartLogin);
